import { useLocale } from 'next-intl';
import { getUrlParams } from '@/_components/custom-header/_utils/get-url-locale-params';
import { ECountries, ELocales } from '@/_types';
import { isObjectValue } from '@/_utils/is-object-value';

type TOutput = {
  locale: ELocales;
  country: ECountries;
};

export const useLocaleCountry = (): TOutput => {
  const nextLocale = useLocale();

  const { country: paramCountry } = getUrlParams();

  const locale = isObjectValue(ELocales, nextLocale) ? nextLocale : ELocales.RU;
  const country = isObjectValue(ECountries, paramCountry)
    ? paramCountry
    : ECountries.RU;

  return {
    locale,
    country,
  };
};
